module.exports = __webpack_public_path__ + "img/Unidad18-3.db09b0f5.png";